import { DialogActions, Grid } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import { Form } from "formik";
import moment from "moment";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  getAnsweredAuthorizationsNotification,
  updateAnsweredAuthorizations,
  updatePendingAuthorizations,
  updateSearchAuthorizations
} from "../../../actions/authorizations";
import { StyledModalFpa } from "../../styled/modalFpa";
import CustomDialog from "../dialog/customDialog";
import FormikActions from "../formik/formikActions";
import FormikForm from "../formik/formikForm";
import FormikSelect from "../formik/formikSelect";
import FormikTextField from "../formik/formikTextField";
import FormikTextFieldSpeech from "../formik/formikTextFieldSpeech";

export default function ModalFPAState({
  open,
  handleClose,
  autorizacion,
  estadoSeleccionado,
  setEstadoSeleccionado,
  fechaAutorizacionSeleccionada,
  setFechaAutorizacionSeleccionada,
  codigoAutorizacion,
  setCodigoAutorizacion,
  observacionesAutorizacion,
  setobservacionesAutorizacion,
  isAnswered,
  disabled,
  isSearch,
  handleOpenConfirmDialog,
  onUpdate
}) {
  const dispatch = useDispatch();

  const title = "Nuevo estado";
  let options = [
    "Pendiente",
    "Auditoria",
    "Autorizado",
    "Derivado",
    "Parcial",
    "Rechazado",
    "SinRespArt",
  ];
  const maxLengthCodigoAutorizacion = 15;
  const maxLengthObservacionesArt = 100;

  if (autorizacion) {
    options = options.filter((each) => each !== autorizacion.estado);
  }

  const validationSchema = Yup.object({
    estado: Yup.string().required("Estado es requerido"),
    fechaAutorizacion: Yup.date()
      .required("Fecha de autorización es requerida")
      .test(
        'is-after-start',
        `La fecha debe ser posterior o igual a la fecha del pedido de autorización ${autorizacion ? moment(autorizacion.fecha).format("DD/MM/yyyy") : ''}`,
        function (value) {
          if (!value || !autorizacion?.fecha) return true;
          return moment(new Date(value)).diff(
            moment(new Date(autorizacion.fecha)).format("YYYY-MM-DDT00:00:00")
          ) >= 0;
        }
      ),
    codigoAutorizacion: Yup.string()
      .max(
        maxLengthCodigoAutorizacion,
        `Máximo ${maxLengthCodigoAutorizacion} caracteres.`
      ),
    observacionesAutorizacion: Yup.string()
      .max(
        maxLengthObservacionesArt,
        `Máximo ${maxLengthObservacionesArt} caracteres.`
      ),
  });

  const initialValues = {
    estado: estadoSeleccionado || "",
    fechaAutorizacion: fechaAutorizacionSeleccionada || moment().format("YYYY-MM-DDT00:00:00"),
    codigoAutorizacion: codigoAutorizacion || "",
    observacionesAutorizacion: observacionesAutorizacion || ""
  };

  const handleSubmit = (values) => {
    const artId = autorizacion.artMLCloud;
    const modeloAutorizacion = {
      siniestroId: autorizacion.siniestroId,
      nroFormulario: autorizacion.nroFormulario,
      estado: values.estado,
      fechaAutorizacion: values.fechaAutorizacion,
      codigoAutorizacion: values.codigoAutorizacion,
      observacionesAutorizacion: values.observacionesAutorizacion,
    };

    if (isAnswered && !isSearch) {
      dispatch(updateAnsweredAuthorizations(artId, modeloAutorizacion)).then(
        () => onUpdate()
      );
    } else if (isSearch) {
      dispatch(updateSearchAuthorizations(artId, modeloAutorizacion)).then(
        () => onUpdate()
      );
    } else {
      dispatch(updatePendingAuthorizations(artId, modeloAutorizacion)).then(
        () => dispatch(getAnsweredAuthorizationsNotification()),
      );
    }
    handleClose();
  };

  return autorizacion ? (
    <div>
      <CustomDialog open={open} onClose={handleOpenConfirmDialog}>
        <DialogTitle>{title}</DialogTitle>
        <FormikForm
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <Form>

              <DialogContent sx={StyledModalFpa.dialogContent}>
                <StyledModalFpa.Form>
                  <Grid container direction={"row"} spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <FormikSelect
                        name="estado"
                        label="Estado"
                        disabled={disabled}
                        required
                        variant="standard"
                        helperText="Requerido"
                      >
                        {options.map((option, index) => (
                          <MenuItem key={index} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </FormikSelect>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <StyledModalFpa.DatePicker
                        slotProps={{
                          textField: {
                            variant: 'standard',
                            error: formikProps.touched.fechaAutorizacion && Boolean(formikProps.errors.fechaAutorizacion),
                            helperText: formikProps.touched.fechaAutorizacion && formikProps.errors.fechaAutorizacion
                              ? formikProps.errors.fechaAutorizacion
                              : "",
                          }
                        }}
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="dateFrom"
                        label="Fecha de autorización"
                        value={new Date(formikProps.values.fechaAutorizacion)}
                        autoOk
                        disableFuture
                        invalidDateMessage="Fecha inválida"
                        invalidLabel="Fecha inválida"
                        minDate={autorizacion.fecha ? moment(autorizacion.fecha).format(
                          "YYYY-MM-DDT00:00:00",
                        ) : undefined}
                        minDateMessage="Fecha inválida"
                        maxDateMessage="Fecha inválida"
                        onChange={(e) => {
                          const from = moment(e).format("YYYY-MM-DDT00:00:00");
                          formikProps.setFieldValue("fechaAutorizacion", from);
                        }}
                        onBlur={() => formikProps.setFieldTouched("fechaAutorizacion", true)}
                        required
                        disabled={disabled}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormikTextField
                        name="codigoAutorizacion"
                        label="Código de autorización de la ART"
                        fullWidth
                        disabled={disabled}
                        variant="standard"
                        helperText={`Máximo ${maxLengthCodigoAutorizacion} caracteres.`}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormikTextFieldSpeech
                        id="observacionesAutorizacion"
                        name="observacionesAutorizacion"
                        label="Observaciones de la ART"
                        fullWidth
                        multiline
                        disabled={disabled}
                        variant="outlined"
                        helperText={`Máximo ${maxLengthObservacionesArt} caracteres.`}
                      />
                    </Grid>
                  </Grid>
                </StyledModalFpa.Form>
              </DialogContent>
              <DialogActions>
                <FormikActions
                  handleCancel={handleOpenConfirmDialog}
                  disabled={disabled}
                />
              </DialogActions>
            </Form>
          )}
        </FormikForm>
      </CustomDialog>
    </div>
  ) : null;
}